document.addEventListener("DOMContentLoaded", function () {
    let loadMoreBtn = document.getElementById("load-more-products");
    let loadBackBtn = document.getElementById("load-back-products");

    if (!loadMoreBtn || !loadBackBtn) return;

    let loading = false;
    let productBatches = []; // Store batches of loaded products

    function shuffleProducts(products) {
        for (let i = products.length - 1; i > 0; i--) {
            let j = Math.floor(Math.random() * (i + 1));
            [products[i], products[j]] = [products[j], products[i]]; // Swap elements
        }
    }

    function scrollToElement(element) {
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }

    function loadMoreProducts() {
        if (loading) return;
        loading = true;

        let nextUrl = loadMoreBtn.getAttribute("data-next-url");
        if (!nextUrl) return;

        fetch(nextUrl)
            .then(response => response.text())
            .then(data => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(data, "text/html");

                let newProductsContainer = document.createElement("div");
                newProductsContainer.innerHTML = doc.querySelector("#product-grid").innerHTML;

                let newProducts = Array.from(newProductsContainer.children);
                shuffleProducts(newProducts); // Shuffle new products

                let productGrid = document.getElementById("product-grid");
                let batch = [];

                newProducts.forEach(product => {
                    productGrid.appendChild(product);
                    batch.push(product);
                });

                productBatches.push(batch); // Store batch for load back functionality
                loadBackBtn.disabled = false; // Enable load back button

                // Scroll to the first product of the newly loaded batch
                if (batch.length > 0) {
                    scrollToElement(batch[0]);
                }

                let nextLoadMore = doc.querySelector("#load-more-products");
                if (nextLoadMore) {
                    loadMoreBtn.setAttribute("data-next-url", nextLoadMore.getAttribute("data-next-url"));
                } else {
                    loadMoreBtn.remove();
                }
            })
            .finally(() => {
                loading = false;
            });
    }

    function loadBackProducts() {
        if (productBatches.length === 0) return;

        let lastBatch = productBatches.pop(); // Remove the last batch from the list
        let productGrid = document.getElementById("product-grid");

        // Get the last product before removing the batch
        let lastProductBeforeRemove = productGrid.lastElementChild;

        lastBatch.forEach(product => product.remove()); // Remove elements from DOM

        // Scroll back to the last visible product after removing the batch
        if (productBatches.length > 0 && lastProductBeforeRemove) {
            scrollToElement(productGrid.lastElementChild);
        } else {
            loadBackBtn.disabled = true; // Disable button if no more products to remove
        }
    }

    // Load More Button Click Event
    loadMoreBtn.addEventListener("click", loadMoreProducts);

    // Load Back Button Click Event
    loadBackBtn.addEventListener("click", loadBackProducts);
});